import { dispatchVugelMouseEvent, } from "./index";
import { getCurrentContext } from "./utils";
const translateEvent = (stage, e) => {
    var _a, _b;
    let currentTouch;
    const eventType = e.type;
    if (eventType === "touchend" || eventType === "touchcancel") {
        currentTouch = e.changedTouches[0];
    }
    else {
        currentTouch = e.touches[0];
    }
    const { currentElement, canvasOffsetX, canvasOffsetY } = getCurrentContext(currentTouch, stage);
    const currentNode = currentElement === null || currentElement === void 0 ? void 0 : currentElement.element.data;
    return {
        cancelBubble: false,
        // Event
        type: e.type,
        currentTarget: currentNode !== null && currentNode !== void 0 ? currentNode : null,
        target: currentNode !== null && currentNode !== void 0 ? currentNode : null,
        // MouseEvent
        canvasOffsetX: canvasOffsetX,
        canvasOffsetY: canvasOffsetY,
        elementOffsetX: (_a = currentElement === null || currentElement === void 0 ? void 0 : currentElement.offsetX) !== null && _a !== void 0 ? _a : 0,
        elementOffsetY: (_b = currentElement === null || currentElement === void 0 ? void 0 : currentElement.offsetY) !== null && _b !== void 0 ? _b : 0,
        originalEvent: e,
        currentElement: currentElement,
    };
};
// https://www.w3.org/TR/touch-events/#list-of-touchevent-types
const dispatchTouchEvent = (stage, eventState) => {
    return (e) => {
        const translatedEvent = translateEvent(stage, e);
        let correspondingMouseEvent;
        switch (e.type) {
            case "touchstart":
                correspondingMouseEvent = "mousedown";
                break;
            case "touchend":
            case "touchcancel":
                correspondingMouseEvent = "mouseup";
                break;
            case "touchmove":
                correspondingMouseEvent = "mousemove";
                break;
        }
        const translatedMouseEvent = Object.assign(Object.assign({}, translatedEvent), { type: correspondingMouseEvent, currentElement: translatedEvent.currentElement });
        dispatchVugelMouseEvent(translatedMouseEvent, eventState);
    };
};
export const touchEventTranslator = {
    touchcancel: "onTouchcancel",
    touchend: "onTouchend",
    touchmove: "onTouchmove",
    touchstart: "onTouchstart",
};
export const setupTouchEvents = (targetElement, stage) => {
    const eventState = {};
    for (const key in touchEventTranslator) {
        targetElement.addEventListener(key, dispatchTouchEvent(stage, eventState));
    }
};
//# sourceMappingURL=touchEvents.js.map